import React from 'react';
import { Icon } from '@iconify-icon/react';

const problems = [
  {
    number: '01',
    icon: 'tabler:server',
    title: 'It gets stored',
    body: 'When you paste a contract, a patient note, or a client email into a free chatbot, a copy usually lives on the provider’s servers — sometimes for years, on terms that can change after the fact.',
  },
  {
    number: '02',
    icon: 'tabler:brain',
    title: 'It can train the next model',
    body: 'Several major AI companies use consumer conversations to train future models by default — unless you find the setting and opt out. Your confidential text can become part of what the AI “knows.”',
  },
  {
    number: '03',
    icon: 'tabler:gavel',
    title: 'It can surface in court',
    body: 'AI chat logs are discoverable. Courts have already ordered a major provider to hand over millions of user conversations in litigation — and ruled that work done in a consumer AI tool may carry no legal privilege at all.',
  },
];

const TheProblem: React.FC = () => (
  <section aria-label="How chatbots usually treat your data" className="bg-white py-20 sm:py-24">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl">
        <span className="text-[11px] font-semibold uppercase tracking-[0.24em] text-[#b8862e]">
          The problem
        </span>
        <h2 className="mt-3 text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl">
          Free AI is rarely{' '}
          <span className="font-display font-medium italic text-[#004790]">free</span>.
          <br />
          You pay with your words.
        </h2>
        <p className="mt-4 text-lg leading-relaxed text-gray-500">
          Here is what typically happens to a conversation in a consumer chatbot on default settings
          &mdash; in plain English.
        </p>
      </div>

      <div className="mt-12 grid gap-8 md:grid-cols-3">
        {problems.map((item) => (
          <div
            key={item.number}
            className="group relative rounded-2xl border border-gray-100 bg-gray-50/50 p-7 transition-all duration-300 hover:-translate-y-1 hover:border-blue-100 hover:bg-white hover:shadow-lg hover:shadow-blue-500/5">
            <div className="flex items-start justify-between">
              <Icon icon={item.icon} className="text-3xl text-[#004790]" />
              <span className="font-display text-4xl font-light italic text-gray-200 transition-colors group-hover:text-[#d3a641]/40">
                {item.number}
              </span>
            </div>
            <h3 className="mt-5 text-lg font-bold text-gray-900">{item.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-gray-500">{item.body}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default TheProblem;
